if(instagram_enable) {
    if (typeof(instagram_token) != 'undefined' && typeof(instagram_id) != 'undefined' ) {
        if ($('.instagram-block-footer #instafeed').length) {
            var feed = new Instafeed({
                get: 'user',
                userId: instagram_id,
                accessToken: instagram_token,
                limit: $('.instagram-block-footer #instafeed').attr('data-count'),
                template: '<div class="insta-item"><a href="{{link}}"><img src="{{image}}" /></a></div>',

                after: function () {
                    external();
                },
            });
            feed.run();

            function external() {
                jQuery(document).ready(function ($) {
                    $('#instafeed a').attr('target', '_blank');
                });
            }
        }
        if ($('.instagram_section #instafeed').length) {
            var feed = new Instafeed({
                get: 'user',
                userId: instagram_id,
                accessToken: instagram_token,
                limit: '6',
                resolution: 'standard_resolution',
                template: '<div class="insta-item  grid-item col-xl-2 col-lg-2 col-md-4 col-6"><a href="{{link}}"><img src="{{image}}" /><div class="insta-hover"> <div class="instagram-icon"><i>+</i></div></div></a></div>',

            });
            feed.run();

            function external() {
                jQuery(document).ready(function ($) {
                    $('#instafeed a').attr('target', '_blank');
                });
            }
        }
    }
}